<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <div class="d-flex flex-column">
    <div class="flex-grow-1 p-relative">
      <div class="anchored scrollable" ref="scrollable">
        <slot></slot>
        <div class="container">
          <div class="p-2">
            <template v-for="m in messages">
              <text-message
                :key="m.id"
                :alternate="m.id === loggedUser.id"
                :user="m.sender.firstName + ' ' + m.sender.lastName"
                :text="m.text"
                :timestamp="timestampFor(m)"
                :variant="variantFor(m)"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="border-top border-secondary" v-if="!disabled">
      <b-input-group>
        <b-textarea
          rows="2"
          max-rows="5"
          v-model="text"
          @keydown.enter.exact.prevent
          @keyup.enter.exact.prevent="post"
          @keydown.enter.shift.exact="newline"
        ></b-textarea>
        <b-input-group-append>
          <b-button
            variant="primary"
            class="h-100 mh-100"
            :disabled="!text || !text.trim()"
            @click.prevent="post()"
          >
            <i class="fa fa-paper-plane"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>

    <!--
      :stacked="isSmDown"
    -->
  </div>
</template>
<script>
import http from "core/http/HttpService";
import { error2text, formatDateTime, downloadBlob } from "core/utils";

export default {
  props: {
    context: {
      type: String,
      required: true
    },

    contextId: {
      type: [String, Number],
      required: true
    },

    subcontext: {
      type: String,
      required: true
    },

    /*
    externalContext: {
      type: String,
      default: null
    },

    externalContextId: {
      type: [String, Number],
      default: null
    },
    */

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      messages: [],
      text: null
    };
  },

  watch: {
    context: "loadMessages",
    contextId: "loadMessages",
    subcontext: "loadMessages"
    /*
    externalContext: 'loadMessages',
    externalContextId: 'loadMessages',
    */
  },

  mounted() {
    this.loadMessages();
  },

  updated() {
    this.scroll();
  },

  methods: {
    loadMessages() {
      const success = ({ statusCode, data }) => {
        console.log("Messages correctly loaded:", statusCode, data);
        this.messages = data;
        //this.scroll();
      };

      const error = ({ statusCode, data }) => {
        console.log("Messages loading error:", statusCode, data);
        alert(error2text(data));
      };

      let url =
        this.$env.baseUrl +
        "/" +
        this.context +
        "/" +
        this.contextId +
        "/messages/" +
        this.subcontext;

      /*
      if (this.externalContext && this.externalContextId) {
        url += '/ext/' + this.externalContext
            + '/' + this.externalContextId;
      }
      */

      http
        .get({
          url
        })
        .then(success, error);
    },

    // =========================================================================

    exportMessages() {
      const filename = "messages.xlsx";

      const success = ({ statusCode, data }) => {
        console.log("Messages correctly loaded:", statusCode, data);
        downloadBlob(data, filename);
        //this.scroll();
      };

      const error = ({ statusCode, data }) => {
        console.log("Messages loading error:", statusCode, data);
        alert(error2text(data));
      };

      let url =
        this.$env.baseUrl +
        "/" +
        this.context +
        "/" +
        this.contextId +
        "/messages/" +
        this.subcontext;

      /*
      if (this.externalContext && this.externalContextId) {
        url += '/ext/' + this.externalContext
            + '/' + this.externalContextId;
      }
      */

      url += "?export=XLSX";

      http
        .get({
          url,
          blob: true
        })
        .then(success, error);

      return false;
    },

    // =========================================================================

    post() {
      console.log("Posting message");

      if (!this.text || !this.text.trim()) {
        return;
      }

      const success = ({ statusCode, data }) => {
        console.log("Message correctly posted:", statusCode, data);
        this.loading = false;
        this.text = null;
        //this.scroll();
      };

      const error = ({ statusCode, data }) => {
        console.log("Message posting error:", statusCode, data);
        this.loading = false;
      };

      this.loading = true;

      let url =
        this.$env.baseUrl +
        "/" +
        this.context +
        "/" +
        this.contextId +
        "/messages/" +
        this.subcontext;

      /*
      if (this.externalContext && this.externalContextId) {
        url += '/ext/' + this.externalContext
            + '/' + this.externalContextId;
      }
      */

      http
        .post({
          url,
          data: {
            text: this.text.trim()
          }
        })
        .then(success, error);
    },

    newline() {
      console.log("Newline");
    },

    scroll() {
      const container = this.$refs.scrollable;
      container.scrollTop = container.scrollHeight;
    },

    // =========================================================================

    timestampFor(m) {
      return formatDateTime(m.created, "DD/MM/YYYY HH:mm");
    },

    variantFor(m) {
      if (m.sender.type == "ADMIN") {
        return "danger";
      } else if (m.sender.type == "BROKER") {
        return "warning";
      } else if (m.sender.type == "PROVIDER") {
        return "success";
      } else if (m.sender.type == "CUSTOMER") {
        return "primary";
      } else {
        throw Error("Unsupported");
      }
    },

    // =========================================================================

    addMessage(m) {
      this.messages.push(m);
    }
  }
};
</script>
